import { getKbUrl } from 'vis-exp-editor-common/utils/urls';
const APRIL_1ST_2024_UTC = 1711929600000;
const MANAGE_TICKETS_IN_HELP_DESK = getKbUrl('help-desk/manage-tickets-in-help-desk');
const INBOX_TYPES = {
  inbox: 'Inbox'
};
export { APRIL_1ST_2024_UTC, MANAGE_TICKETS_IN_HELP_DESK, INBOX_TYPES };